import React from 'react';
import { ApolloProvider } from '@apollo/client';
// import { useHistory } from 'react-router-dom'; // v5 hook
import client from 'helpers/client';
// library CSS
import './assets/fonts/style.css';
import 'swiper/swiper.css';
import 'react-quill/dist/quill.snow.css';
import Theme from 'settings/theme';

// import { datadogRum } from '@datadog/browser-rum';
import GlobalStyle from './global.style';

import RouterWrapper from './RouterWrapper';
// import { updateFcmToken } from 'graphql/queries/users';

// if (process.env.NODE_ENV === 'production') {
//   datadogRum.init({
//     applicationId: process.env.REACT_APP_DATADOG_RUM_APP_ID,
//     clientToken: process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
//     site: process.env.REACT_APP_DATADOG_RUM_SITE,
//     service: process.env.REACT_APP_DATADOG_RUM_SERVICE,
//     env: process.env.REACT_APP_ENVIRONMENT,
//     sampleRate: 100,
//     premiumSampleRate: 100,
//     trackInteractions: true,
//     defaultPrivacyLevel: 'mask-user-input',
//   });

//   datadogRum.startSessionReplayRecording();
// }

const App = () => {
  // const history = useHistory();

  // useEffect(() => {
  //   if (!('serviceWorker' in navigator)) return;

  //   const handler = (event: MessageEvent) => {
  //     console.log("GETTING SERVICE WORKER MESSAGE");
  //     const data = event.data;
  //     if (data?.type === 'NAVIGATE' && typeof data.url === 'string') {
  //       console.log('Navigating to ', data.url);
  //       // const url = new URL(data.url);
  //       window.location.href = data.url;
  //     }
  //   };

  //   navigator.serviceWorker.addEventListener('message', handler);
  //   return () => {
  //     navigator.serviceWorker.removeEventListener('message', handler);
  //   };
  // }, [history]);

  // Notification permission is now requested from the Notification component via a soft prompt.

  return (
    <Theme>
      <ApolloProvider client={client}>
        <RouterWrapper />
        <GlobalStyle />

      </ApolloProvider>
    </Theme>
  );
};
export default App;
